import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { convertStoreUserNonAvailability } from './shared/convert'
import keys from './shared/keys'
import { StoreUserNonAvailabilityResponse } from './shared/response'
import { StoreUserNonAvailability, UpdateNonAvailabilityParams } from './types'

type Variables = UpdateNonAvailabilityParams

export function useAddNonAvailability() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: addNonAvailability,
    onSuccess: async () => {
      client.invalidateQueries({ queryKey: keys.all }).catch(() => null)
    },
  })

  async function addNonAvailability(
    updateParams: Variables
  ): Promise<StoreUserNonAvailability> {
    const response =
      await server.post<StoreUserNonAvailabilityResponse.StoreUserNonAvailability>(
        '/v2/non_availability',
        {
          user_id: updateParams.userId,
          store_id: updateParams.storeId,
          approver_id: updateParams.approverId,
          status: updateParams.status,
          non_availabilities: updateParams.nonAvailabilities?.map(
            nonAvailability => ({
              dow: Number(nonAvailability.dayOfWeek),
              shift_block_id: Number(nonAvailability.shiftBlockId),
            })
          ),
        }
      )

    return convertStoreUserNonAvailability(response)
  }
}
